<template>
  <header class="bg-light">
    <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div class="site-logo-wrap">
        <router-link to="/" class="site-logo" :aria-label="$t('website')">
          <img src="/img/cp/logo_new.svg" alt="" class="site-logo__img" />
        </router-link>
      </div>
      <div class="header-contact text-end p-3 d-flex flex-column align-items-end">
        <div class="assistance d-flex ">
          <img src="/img/cp/ec_logo_small.png" style="width: 50px; height: 55px" alt="assistance logo" />
          <div style="margin-left: 6px">
            <div>{{ $t('contact.assistance.title')}}</div>
            <div>
              <a :href="assistancePhoneHref">{{ $t('contact.assistance.tel')}}</a>
            </div>
          </div>
        </div>
        <div class="contact">
          <a :href="emailHref">{{ $t('contact.email') }}</a><br>
          infolinka: <a :href="phoneHref">{{ $t('contact.tel') }}</a><br>
        </div>
      </div>
    </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderPart",
  props: {
    product: String
  },
  computed: {
    emailHref() {
      const email = String(this.$t('contact.email') || '').replace("{'@'}", '@');
      return `mailto:${email}`;
    },
    phoneHref() {
      const phone = String(this.$t('contact.tel') || '').replace(/[^\d+]/g, '');
      return `tel:${phone}`;
    },
    assistancePhoneHref() {
      const phone = String(this.$t('contact.assistance.tel') || '').replace(/[^\d+]/g, '');
      return `tel:${phone}`;
    }
  }

}
</script>

<style scoped>
  a{ text-decoration: none;
    color: var(--main-color);
  }
  header{
    border-bottom: 1px solid var(--main-color);
  }
  .site-logo-wrap{
    flex-shrink: 0;
    position: relative;
    z-index: 2;
  }
  .site-logo{
    display: block;
    line-height: 0;
    width: fit-content;
    max-width: 100%;
    text-decoration: none;
  }
  .site-logo__img{
    display: block;
    height: 70px;
    width: auto;
    max-width: min(360px, 55vw);
    pointer-events: none;
  }
  .header-contact{
    flex-shrink: 1;
    min-width: 0;
  }

  .assistance{
    font-size: 1.3em;
    line-height: 1.1em;
    color: #ff6900;
  }
  .assistance a{
    margin-top: -10px;
    font-size: 1em;
    color: #ff6900;
  }
  .contact{
    margin-top: -5px;
    color: var(--main-color);
    font-size: 0.8em;
  }


</style>